import {getGlycanAssignments} from "../graphql/queries";
import {API, graphqlOperation} from "aws-amplify";
import {setGsmResults, setSelectedSpectrum} from "./GsmResultsAction";

export const SET_MASS_GROUP = "SET_MASS_GROUP";
export const CLEAR_MASS_GROUP = "CLEAR_MASS_GROUP";

const colorList = [
    '#000000',
    "#00babb",
    "#0188ff",
    "#00614b",
    "#4f0095",
    "#fdc383",
    "#f473ff",
    "#ff441e",
    "#8ae548",
    "#ff34a2",
    "#241f5b"
];

export function setSelectedAssignmentList(glycanAssignments) {
    return {
        type: SET_MASS_GROUP,
        elutionCurve: glycanAssignments
    }
}

export function clearSelectedAssignmentList() {
    return {
        type: CLEAR_MASS_GROUP
    }
}

export function fetchAssignmentList(projectId, massGroup) {

    return (dispatch) => {
        dispatch(clearSelectedAssignmentList());
        dispatch(setGsmResults(undefined));
        dispatch(setSelectedSpectrum({
            peaks:[]
        }));

        API.graphql(
            graphqlOperation(getGlycanAssignments, {groupProjectKey: projectId + "/" + massGroup})
        ).then(result => {
            const items = result.data.getGlycanAssignments.items;
            const structureElutionList = [];
            let runCount = 0;
            const runIndexMap = new Map();
            const colorIndexMap = new Map();
            colorIndexMap.set(null, 0);
            let colorCount = 1;
            for (let i = 0; i < items.length; i++) {

                const item = items[i];
                const runId = item.runId;
                if (!runIndexMap.has(runId)) {

                    runIndexMap.set(runId, runCount);
                    runCount += 1;
                }
                const runIndex = runIndexMap.get(runId);

                const structureId = item.structureId;
                if(!colorIndexMap.has(structureId))
                    colorIndexMap.set(structureId, colorCount += 1);
                const structureIndex = colorIndexMap.get(structureId);
                structureElutionList.push({
                    key: structureId,
                    rtMin: item.minRetentionTime,
                    rtWidth: item.maxRetentionTime - item.minRetentionTime,
                    runIndex: runIndex,
                    openMetaScore: item.openMetaScore,
                    gsmKey: {
                        projectId: projectId,
                        runId: runId,
                        preClusterId: item.preClusterId,
                        clusterId: item.clusterId,
                        massGroup: massGroup,
                        structureId: item.structureId
                    },
                    fill: structureIndex < colorList.length ? colorList[structureIndex] : '#8884d8'
                });
            }
            return {
                runCount: runCount,
                structureElutionList: structureElutionList,
            };
        }).then(
            result => dispatch(setSelectedAssignmentList(result))
        ).catch((e) => {
            console.log("There was an error fetching the mass group");
            console.log(e);
        });
    }
}